import { Tour, TourRunOptions } from '@tlx/tourme-core';
import { useEffect } from 'react';

export function useTour(
    tour: Tour,
    shouldRun: boolean,
    nextRunOptions?: TourRunOptions,
) {
    useEffect(() => {
        if (shouldRun) {
            runTour(tour, nextRunOptions);
        }
    }, [tour, shouldRun, nextRunOptions]);
}

export function runTour(tour: Tour, nextRunOptions?: TourRunOptions) {
    if (window.TourMe?.status()?.status === 'idle') {
        window.TourMe?.run(tour, nextRunOptions);
    }
}
